import { useMemo } from "react";

import { useAuth } from "../AuthContext";
import { useAppStore } from "../../hooks/useAppStore";
import { IFCCapabilities } from "../../types/auth";

const DEFAULT_SETTINGS = {
  header: {
    home: true,
    claims: true,
    dashboard: true,
    policies: false,
    contracts: false,
  },
};

// Controlled by different permissions (see useCapabilities)
const DEFAULT_EXTERNAL_SETTINGS = {
  header: null,
};

/**
 * Custom hook to check if a specific component has visibility permission
 * Keep settings to null on is_external true -> visibility is controlled by useCapabilities
 * @returns The FC capability flags
 */
export const useFCCapabilities = (): IFCCapabilities => {
  const appStore = useAppStore();
  const { is_external } = useAuth();

  const settings = useMemo(() => {
    if (is_external) {
      return DEFAULT_EXTERNAL_SETTINGS;
    }

    const header = {
      ...DEFAULT_SETTINGS.header,
      ...(appStore.headerConfigFlags || {}),
    };

    return {
      ...DEFAULT_SETTINGS,
      header,
    };
  }, [is_external, appStore.headerConfigFlags]);

  return settings;
};
